import { Button, Tooltip } from "antd";
import { sizePrimaryBtn } from "../styles";

export default function Buttons(args) {
  return (
    <div
      className="buttons"
      style={{
        display: "flex",
        gap: "1rem",
        flexDirection: args.device === "phone" ? "column" : "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {args.buttonsPrimary &&
        args.buttonsPrimary.map((text, index) => (
          <Tooltip
            arrow={false}
            title={args.tooltipPrimary && args.tooltipPrimary[index]}
            color={"white"}
          >
            <Button
              style={sizePrimaryBtn}
              type="primary"
              onClick={args.onClickPrimary}
              key={index}
              icon={args.iconsPrimary && args.iconsPrimary[index]}
              iconPlacement={args.iconPlacement && args.iconPlacement}
              disabled={args.disabledPrimary && args.disabledPrimary[index]}
              href={args.hrefPrimary && args.hrefPrimary[index]}
            >
              {text}
            </Button>
          </Tooltip>
        ))}
      {args.buttons &&
        args.buttons.map((text, index) => (
          <Tooltip
            arrow={false}
            title={args.tooltip && args.tooltip[index]}
            color={"white"}
          >
            <Button
              style={sizePrimaryBtn}
              key={index}
              icon={args.icons && args.icons[index]}
              iconPlacement={args.iconPlacement && args.iconPlacement}
              disabled={args.disabled && args.disabled[index]}
              href={args.href && args.href[index]}
            >
              {text}
            </Button>
          </Tooltip>
        ))}
    </div>
  );
}
